import React from 'react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

const statusConfig = {
  // Leave statuses
  pending: { 
    label: 'Pending', 
    className: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100' 
  },
  approved: { 
    label: 'Approved', 
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100' 
  },
  rejected: { 
    label: 'Rejected', 
    className: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-100' 
  },
  cancelled: { 
    label: 'Cancelled', 
    className: 'bg-slate-50 text-slate-600 border-slate-200 hover:bg-slate-100' 
  },
  
  // Employee statuses
  active: { 
    label: 'Active', 
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100' 
  },
  inactive: { 
    label: 'Inactive', 
    className: 'bg-slate-50 text-slate-600 border-slate-200 hover:bg-slate-100' 
  },
  invited: { 
    label: 'Invited', 
    className: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100' 
  },
  
  // General statuses
  success: { 
    label: 'Success', 
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100' 
  },
  error: { 
    label: 'Error', 
    className: 'bg-red-50 text-red-700 border-red-200 hover:bg-red-100' 
  },
  warning: { 
    label: 'Warning', 
    className: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100' 
  },
  info: { 
    label: 'Info', 
    className: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100' 
  },
}

export function StatusBadge({
  status,
  label,
  className,
  ...props
}) {
  const config = statusConfig[status?.toLowerCase()] || { 
    label: status, 
    className: 'bg-slate-50 text-slate-600 border-slate-200' 
  }
  const displayLabel = label || config.label

  return (
    <Badge
      variant="outline"
      className={cn(
        "font-medium border",
        config.className,
        className
      )}
      {...props}
    >
      {displayLabel}
    </Badge>
  )
}

export function RoleBadge({ role, className }) {
  const roleConfig = {
    admin: { 
      label: 'Admin', 
      className: 'bg-purple-50 text-purple-700 border-purple-200 hover:bg-purple-100' 
    },
    hr: { 
      label: 'HR', 
      className: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100' 
    },
    employee: { 
      label: 'Employee', 
      className: 'bg-slate-50 text-slate-600 border-slate-200 hover:bg-slate-100' 
    },
  }

  const config = roleConfig[role?.toLowerCase()] || { 
    label: role, 
    className: 'bg-slate-50 text-slate-600 border-slate-200' 
  }

  return (
    <Badge
      variant="outline"
      className={cn(
        "font-medium border",
        config.className,
        className
      )}
    >
      {config.label}
    </Badge>
  )
}

export default StatusBadge
